module.exports = __webpack_public_path__ + "static/TT2-evergreen-page-screening-sales-weight-iStock-1331259098.20ae7b2e.jpg";